export default {
  Lessons: {
    Lesson: "Урок",
    status: {
      success: "Пройден",
      unsuccess: "Не пройден",
      stop: "Недоступно",
    },
  },
};
